export default __webpack_public_path__ + "static/BestSupport-2bff171107a2606f19d431eb13e91de6.svg";